interface Master {[key: string]: {ja: string, en:string}}

const languageLabel: Master = {
  aar: { ja: 'アファル語', en: 'en_アファル語' },
  abk: { ja: 'アブハズ語', en: 'en_アブハズ語' },
  ace: { ja: 'アチェ語', en: 'en_アチェ語' },
  ach: { ja: 'アチョリ語', en: 'en_アチョリ語' },
  ada: { ja: 'アダグメ語', en: 'en_アダグメ語' },
  ady: { ja: 'アディゲ語', en: 'en_アディゲ語' },
  afa: { ja: 'アフロ・アジア語族(その他)', en: 'en_アフロ・アジア語族(その他)' },
  afh: { ja: 'アフリヒリ', en: 'en_アフリヒリ' },
  afr: { ja: 'アフリカーンス語', en: 'en_アフリカーンス語' },
  ain: { ja: 'アイヌ語', en: 'en_アイヌ語' },
  aka: { ja: 'アカン語', en: 'en_アカン語' },
  akk: { ja: 'アッカド語', en: 'en_アッカド語' },
  alb: { ja: 'アルバニア語', en: 'en_アルバニア語' },
  sqi: { ja: 'アルバニア語', en: 'en_アルバニア語' },
  ale: { ja: 'アリュート語', en: 'en_アリュート語' },
  alg: { ja: 'アルゴンキン語族', en: 'en_アルゴンキン語族' },
  alt: { ja: '南アルタイ語', en: 'en_南アルタイ語' },
  amh: { ja: 'アムハラ語', en: 'en_アムハラ語' },
  ang: { ja: '古英語', en: 'en_古英語' },
  anp: { ja: 'アンガ語', en: 'en_アンガ語' },
  apa: { ja: 'アパッチ語族', en: 'en_アパッチ語族' },
  ara: { ja: 'アラビア語', en: 'en_アラビア語' },
  arc: { ja: 'アラム語', en: 'en_アラム語' },
  arg: { ja: 'アラゴン語', en: 'en_アラゴン語' },
  arm: { ja: 'アルメニア語', en: 'en_アルメニア語' },
  hye: { ja: 'アルメニア語', en: 'en_アルメニア語' },
  arn: { ja: 'アラウコ語族', en: 'en_アラウコ語族' },
  arp: { ja: 'アラパホ語', en: 'en_アラパホ語' },
  art: { ja: '人工言語(その他)', en: 'en_人工言語(その他)' },
  arw: { ja: 'アラワク語族', en: 'en_アラワク語族' },
  asm: { ja: 'アッサム語', en: 'en_アッサム語' },
  ast: { ja: 'アストゥリアス語', en: 'en_アストゥリアス語' },
  ath: { ja: 'アサパスカ語族', en: 'en_アサパスカ語族' },
  aus: { ja: 'オーストラリア先住民語', en: 'en_オーストラリア先住民語' },
  ava: { ja: 'アバール語', en: 'en_アバール語' },
  ave: { ja: 'アベスタ語', en: 'en_アベスタ語' },
  awa: { ja: 'アワディー語', en: 'en_アワディー語' },
  aym: { ja: 'アイマラ語', en: 'en_アイマラ語' },
  aze: { ja: 'アゼルバイジャン語', en: 'en_アゼルバイジャン語' },
  bad: { ja: 'バンダ語', en: 'en_バンダ語' },
  bai: { ja: 'バミレケ諸語', en: 'en_バミレケ諸語' },
  bak: { ja: 'バシュキール語', en: 'en_バシュキール語' },
  bal: { ja: 'バルーチー語', en: 'en_バルーチー語' },
  bam: { ja: 'バンバラ語', en: 'en_バンバラ語' },
  ban: { ja: 'バリ語', en: 'en_バリ語' },
  baq: { ja: 'バスク語', en: 'en_バスク語' },
  eus: { ja: 'バスク語', en: 'en_バスク語' },
  bas: { ja: 'バサ語', en: 'en_バサ語' },
  bat: { ja: 'バルト語派(その他)', en: 'en_バルト語派(その他)' },
  bej: { ja: 'ベジャ語', en: 'en_ベジャ語' },
  bel: { ja: '白ロシア語；ベラルーシ語', en: 'en_白ロシア語；ベラルーシ語' },
  bem: { ja: 'ベンバ語', en: 'en_ベンバ語' },
  ben: { ja: 'ベンガル語', en: 'en_ベンガル語' },
  ber: { ja: 'ベルベル語派(その他)', en: 'en_ベルベル語派(その他)' },
  bho: { ja: 'ボージュプリー語', en: 'en_ボージュプリー語' },
  bih: { ja: 'ビハール語', en: 'en_ビハール語' },
  bik: { ja: 'ビコル小語群', en: 'en_ビコル小語群' },
  bin: { ja: 'ビニ語', en: 'en_ビニ語' },
  bis: { ja: 'ビスラマ語', en: 'en_ビスラマ語' },
  bla: { ja: 'ブラックフット語', en: 'en_ブラックフット語' },
  bnt: { ja: 'バントゥ諸語(その他)', en: 'en_バントゥ諸語(その他)' },
  bos: { ja: 'ボスニア語', en: 'en_ボスニア語' },
  bra: { ja: 'ブラジ語', en: 'en_ブラジ語' },
  bre: { ja: 'ブルトン語', en: 'en_ブルトン語' },
  btk: { ja: 'バタク語(インドネシア)', en: 'en_バタク語(インドネシア)' },
  bua: { ja: 'ブリヤート語', en: 'en_ブリヤート語' },
  bug: { ja: 'ブギス語', en: 'en_ブギス語' },
  bul: { ja: 'ブルガリア語', en: 'en_ブルガリア語' },
  bur: { ja: 'ビルマ語；ミャンマー語', en: 'en_ビルマ語；ミャンマー語' },
  mya: { ja: 'ビルマ語；ミャンマー語', en: 'en_ビルマ語；ミャンマー語' },
  byn: { ja: 'ビリン語', en: 'en_ビリン語' },
  cad: { ja: 'カド語', en: 'en_カド語' },
  cai: { ja: '中米インディアン諸語(その他)', en: 'en_中米インディアン諸語(その他)' },
  car: { ja: 'カリブ語', en: 'en_カリブ語' },
  cat: { ja: 'カタロニア語', en: 'en_カタロニア語' },
  cau: { ja: 'カフカース諸語(その他)', en: 'en_カフカース諸語(その他)' },
  ceb: { ja: 'セブアノ語', en: 'en_セブアノ語' },
  cel: { ja: 'ケルト語派(その他)', en: 'en_ケルト語派(その他)' },
  cha: { ja: 'チャモロ語', en: 'en_チャモロ語' },
  chb: { ja: 'チブチャ語族', en: 'en_チブチャ語族' },
  che: { ja: 'チェチェン語', en: 'en_チェチェン語' },
  chg: { ja: 'チャガタイ語', en: 'en_チャガタイ語' },
  chi: { ja: '中国語', en: 'en_中国語' },
  zho: { ja: '中国語', en: 'en_中国語' },
  chk: { ja: 'トラック語', en: 'en_トラック語' },
  chm: { ja: 'マリ語', en: 'en_マリ語' },
  chn: { ja: 'チヌーク・ジャーゴン', en: 'en_チヌーク・ジャーゴン' },
  cho: { ja: 'チョクトー語', en: 'en_チョクトー語' },
  chp: { ja: 'チペワイアン語', en: 'en_チペワイアン語' },
  chr: { ja: 'チェロキー語', en: 'en_チェロキー語' },
  chu: { ja: '教会スラブ語', en: 'en_教会スラブ語' },
  chv: { ja: 'チュワシュ語', en: 'en_チュワシュ語' },
  chy: { ja: 'シャイアン語', en: 'en_シャイアン語' },
  cmc: { ja: 'チャム諸語', en: 'en_チャム諸語' },
  cop: { ja: 'コプト語', en: 'en_コプト語' },
  cor: { ja: 'コーンウォール語', en: 'en_コーンウォール語' },
  cos: { ja: 'コルシカ語', en: 'en_コルシカ語' },
  cpe: { ja: '英語系クレオル諸語及びピジン語(その他)', en: 'en_英語系クレオル諸語及びピジン語(その他)' },
  cpf: { ja: 'フランス語系クレオル諸語及びピジン語(その他)', en: 'en_フランス語系クレオル諸語及びピジン語(その他)' },
  cpp: { ja: 'ポルトガル語系クレオル諸語及びピジン語(その他)', en: 'en_ポルトガル語系クレオル諸語及びピジン語(その他)' },
  cre: { ja: 'クリー語', en: 'en_クリー語' },
  crh: { ja: 'クリム・タタール語；クリム・トルコ語', en: 'en_クリム・タタール語；クリム・トルコ語' },
  crp: { ja: 'クレオル諸語及びピジン語(その他)', en: 'en_クレオル諸語及びピジン語(その他)' },
  csb: { ja: 'カシューブ語', en: 'en_カシューブ語' },
  cus: { ja: 'クシュ語派(その他)', en: 'en_クシュ語派(その他)' },
  cze: { ja: 'チェコ語', en: 'en_チェコ語' },
  ces: { ja: 'チェコ語', en: 'en_チェコ語' },
  dak: { ja: 'ダコタ語', en: 'en_ダコタ語' },
  dan: { ja: 'デンマーク語', en: 'en_デンマーク語' },
  dar: { ja: 'ダルグワ語', en: 'en_ダルグワ語' },
  day: { ja: 'ダヤク語', en: 'en_ダヤク語' },
  del: { ja: 'デラウエア語', en: 'en_デラウエア語' },
  den: { ja: 'スレイビー語', en: 'en_スレイビー語' },
  dgr: { ja: 'ドグリブ語', en: 'en_ドグリブ語' },
  din: { ja: 'ディンカ語', en: 'en_ディンカ語' },
  div: { ja: 'ディベヒ語；モルジブ語', en: 'en_ディベヒ語；モルジブ語' },
  doi: { ja: 'ドーグリー語', en: 'en_ドーグリー語' },
  dra: { ja: 'ドラビダ語族(その他)', en: 'en_ドラビダ語族(その他)' },
  dsb: { ja: '下ソルブ語', en: 'en_下ソルブ語' },
  dua: { ja: 'ドゥアラ語', en: 'en_ドゥアラ語' },
  dum: { ja: '中期オランダ語', en: 'en_中期オランダ語' },
  dut: { ja: 'オランダ語', en: 'en_オランダ語' },
  nld: { ja: 'オランダ語', en: 'en_オランダ語' },
  dyu: { ja: 'ジュラ語', en: 'en_ジュラ語' },
  dzo: { ja: 'ゾンカ語；ブータン語', en: 'en_ゾンカ語；ブータン語' },
  efi: { ja: 'エフィック語', en: 'en_エフィック語' },
  egy: { ja: '古代エジプト語', en: 'en_古代エジプト語' },
  eka: { ja: 'エカジュク語', en: 'en_エカジュク語' },
  elx: { ja: 'エラム語', en: 'en_エラム語' },
  eng: { ja: '英語', en: 'en_英語' },
  enm: { ja: '中期英語', en: 'en_中期英語' },
  epo: { ja: 'エスペラント語', en: 'en_エスペラント語' },
  est: { ja: 'エストニア語', en: 'en_エストニア語' },
  ewe: { ja: 'エウェ語群；エベ語群', en: 'en_エウェ語群；エベ語群' },
  ewo: { ja: 'エウォンド語', en: 'en_エウォンド語' },
  fan: { ja: 'ファン語', en: 'en_ファン語' },
  fao: { ja: 'フェーロー語', en: 'en_フェーロー語' },
  fat: { ja: 'ファンテ語', en: 'en_ファンテ語' },
  fij: { ja: 'フィジー語', en: 'en_フィジー語' },
  fil: { ja: 'フィリピノ語；ピリピノ語', en: 'en_フィリピノ語；ピリピノ語' },
  fin: { ja: 'フィンランド語', en: 'en_フィンランド語' },
  fiu: { ja: 'フィン・ウゴル語派(その他)', en: 'en_フィン・ウゴル語派(その他)' },
  fon: { ja: 'フォン語', en: 'en_フォン語' },
  fre: { ja: 'フランス語', en: 'en_フランス語' },
  fra: { ja: 'フランス語', en: 'en_フランス語' },
  frm: { ja: '中期フランス語', en: 'en_中期フランス語' },
  fro: { ja: '古フランス語', en: 'en_古フランス語' },
  frr: { ja: '北フリジア語', en: 'en_北フリジア語' },
  frs: { ja: '東フリジア語', en: 'en_東フリジア語' },
  fry: { ja: 'フリジア語；西フリジア語', en: 'en_フリジア語；西フリジア語' },
  ful: { ja: 'フラニ語；フルフルデ語', en: 'en_フラニ語；フルフルデ語' },
  fur: { ja: 'フリウリ語', en: 'en_フリウリ語' },
  gaa: { ja: 'ガー語', en: 'en_ガー語' },
  gay: { ja: 'ガヨ語', en: 'en_ガヨ語' },
  gba: { ja: 'グバヤ方言群', en: 'en_グバヤ方言群' },
  gem: { ja: 'ゲルマン語派(その他)', en: 'en_ゲルマン語派(その他)' },
  geo: { ja: 'グルジア語', en: 'en_グルジア語' },
  kat: { ja: 'グルジア語', en: 'en_グルジア語' },
  ger: { ja: 'ドイツ語', en: 'en_ドイツ語' },
  deu: { ja: 'ドイツ語', en: 'en_ドイツ語' },
  gez: { ja: 'ゲエズ語', en: 'en_ゲエズ語' },
  gil: { ja: 'キリバス語；ギルバート語', en: 'en_キリバス語；ギルバート語' },
  gla: { ja: '高地スコットランド・ゲール語', en: 'en_高地スコットランド・ゲール語' },
  gle: { ja: 'アイルランド語', en: 'en_アイルランド語' },
  glg: { ja: 'ガリシア語', en: 'en_ガリシア語' },
  glv: { ja: 'マン島語', en: 'en_マン島語' },
  gmh: { ja: '中高ドイツ語', en: 'en_中高ドイツ語' },
  goh: { ja: '古高ドイツ語', en: 'en_古高ドイツ語' },
  gon: { ja: 'ゴーンディー語', en: 'en_ゴーンディー語' },
  gor: { ja: 'ゴロンタロ語', en: 'en_ゴロンタロ語' },
  got: { ja: 'ゴート語', en: 'en_ゴート語' },
  grb: { ja: 'グレボ小語群', en: 'en_グレボ小語群' },
  grc: { ja: '古代ギリシア語', en: 'en_古代ギリシア語' },
  gre: { ja: '現代ギリシア語', en: 'en_現代ギリシア語' },
  ell: { ja: '現代ギリシア語', en: 'en_現代ギリシア語' },
  grn: { ja: 'グァラニ語；ワラニー語', en: 'en_グァラニ語；ワラニー語' },
  gsw: { ja: 'スイス・ドイツ語；アレマン語', en: 'en_スイス・ドイツ語；アレマン語' },
  guj: { ja: 'グジャラート語', en: 'en_グジャラート語' },
  gwi: { ja: 'クチン語', en: 'en_クチン語' },
  hai: { ja: 'ハイダ語', en: 'en_ハイダ語' },
  hat: { ja: 'ハイチ語；ハイチ・クレオール語', en: 'en_ハイチ語；ハイチ・クレオール語' },
  hau: { ja: 'ハウサ語', en: 'en_ハウサ語' },
  haw: { ja: 'ハワイ語', en: 'en_ハワイ語' },
  heb: { ja: 'ヘブライ語', en: 'en_ヘブライ語' },
  her: { ja: 'ヘレロ語', en: 'en_ヘレロ語' },
  hil: { ja: 'ヒリガイノン語', en: 'en_ヒリガイノン語' },
  him: { ja: 'ヒマチャリー語', en: 'en_ヒマチャリー語' },
  hin: { ja: 'ヒンディー語', en: 'en_ヒンディー語' },
  hit: { ja: 'ヒッタイト語', en: 'en_ヒッタイト語' },
  hmn: { ja: 'フモン語', en: 'en_フモン語' },
  hmo: { ja: 'ヒリモトゥ語', en: 'en_ヒリモトゥ語' },
  hsb: { ja: '上ソルブ語', en: 'en_上ソルブ語' },
  hun: { ja: 'ハンガリー語；マジャル語', en: 'en_ハンガリー語；マジャル語' },
  hup: { ja: 'フーパ語', en: 'en_フーパ語' },
  iba: { ja: 'イバン語', en: 'en_イバン語' },
  ibo: { ja: 'イグボ語；イボ語', en: 'en_イグボ語；イボ語' },
  ice: { ja: 'アイスランド語', en: 'en_アイスランド語' },
  isl: { ja: 'アイスランド語', en: 'en_アイスランド語' },
  ido: { ja: 'イド語', en: 'en_イド語' },
  iii: { ja: '彝語', en: 'en_彝語' },
  ijo: { ja: 'イジョー方言群', en: 'en_イジョー方言群' },
  iku: { ja: 'イヌイット語；エスキモー語', en: 'en_イヌイット語；エスキモー語' },
  ile: { ja: 'インターリング', en: 'en_インターリング' },
  ilo: { ja: 'イロカノ語', en: 'en_イロカノ語' },
  ina: { ja: 'インターリンガ語', en: 'en_インターリンガ語' },
  inc: { ja: 'インド語派(その他)', en: 'en_インド語派(その他)' },
  ind: { ja: 'インドネシア語', en: 'en_インドネシア語' },
  ine: { ja: 'インド・ヨーロッパ語族(その他)', en: 'en_インド・ヨーロッパ語族(その他)' },
  inh: { ja: 'イングシ語', en: 'en_イングシ語' },
  ipk: { ja: 'イヌピアック語', en: 'en_イヌピアック語' },
  ira: { ja: 'イラン語派(その他)', en: 'en_イラン語派(その他)' },
  iro: { ja: 'イロコイ語族', en: 'en_イロコイ語族' },
  ita: { ja: 'イタリア語', en: 'en_イタリア語' },
  jav: { ja: 'ジャワ語', en: 'en_ジャワ語' },
  jaw: { ja: 'ジャワ語', en: 'en_ジャワ語' },
  jbo: { ja: 'ロジバン語', en: 'en_ロジバン語' },
  jpn: { ja: '日本語', en: 'en_日本語' },
  jpr: { ja: 'ユダヤ・ペルシア語', en: 'en_ユダヤ・ペルシア語' },
  jrb: { ja: 'ユダヤ・アラビア語', en: 'en_ユダヤ・アラビア語' },
  kaa: { ja: 'カラカルパク語', en: 'en_カラカルパク語' },
  kab: { ja: 'カビール語', en: 'en_カビール語' },
  kac: { ja: 'カチン語', en: 'en_カチン語' },
  kal: { ja: 'グリーンランド語', en: 'en_グリーンランド語' },
  kam: { ja: 'カンバ語', en: 'en_カンバ語' },
  kan: { ja: 'カンナダ語', en: 'en_カンナダ語' },
  kar: { ja: 'カレン語群', en: 'en_カレン語群' },
  kas: { ja: 'カシュミール語', en: 'en_カシュミール語' },
  kau: { ja: 'カヌリ語', en: 'en_カヌリ語' },
  kaw: { ja: 'カウィ語', en: 'en_カウィ語' },
  kaz: { ja: 'カザフ語', en: 'en_カザフ語' },
  kbd: { ja: 'カバルド語', en: 'en_カバルド語' },
  kha: { ja: 'カシ語', en: 'en_カシ語' },
  khi: { ja: 'コイサン語族(その他)', en: 'en_コイサン語族(その他)' },
  khm: { ja: 'カンボジア語；クメール語', en: 'en_カンボジア語；クメール語' },
  kho: { ja: 'コータン語', en: 'en_コータン語' },
  kik: { ja: 'キクユ語', en: 'en_キクユ語' },
  kin: { ja: 'ルワンダ語', en: 'en_ルワンダ語' },
  kir: { ja: 'キルギス語', en: 'en_キルギス語' },
  kmb: { ja: 'キンブンドゥ語', en: 'en_キンブンドゥ語' },
  kok: { ja: 'コーンカニー語', en: 'en_コーンカニー語' },
  kom: { ja: 'コミ語', en: 'en_コミ語' },
  kon: { ja: 'コンゴ語', en: 'en_コンゴ語' },
  kor: { ja: '韓国語；朝鮮語', en: 'en_韓国語；朝鮮語' },
  kos: { ja: 'コシャエ語', en: 'en_コシャエ語' },
  kpe: { ja: 'クペレ語', en: 'en_クペレ語' },
  krc: { ja: 'カラチャイ・バルカル語', en: 'en_カラチャイ・バルカル語' },
  krl: { ja: 'カレリア語', en: 'en_カレリア語' },
  kro: { ja: 'クルー諸語', en: 'en_クルー諸語' },
  kru: { ja: 'クルク語', en: 'en_クルク語' },
  kua: { ja: 'クワニャマ語', en: 'en_クワニャマ語' },
  kum: { ja: 'クムク語', en: 'en_クムク語' },
  kur: { ja: 'クルド語', en: 'en_クルド語' },
  kut: { ja: 'クーテナイ語', en: 'en_クーテナイ語' },
  lad: { ja: 'ユダヤ・スペイン語', en: 'en_ユダヤ・スペイン語' },
  lah: { ja: 'ラーンダー語', en: 'en_ラーンダー語' },
  lam: { ja: 'ランバ語', en: 'en_ランバ語' },
  lao: { ja: 'ラオ語', en: 'en_ラオ語' },
  lat: { ja: 'ラテン語', en: 'en_ラテン語' },
  lav: { ja: 'ラトビア語', en: 'en_ラトビア語' },
  lez: { ja: 'レズギ語', en: 'en_レズギ語' },
  lim: { ja: 'リンブルガー語', en: 'en_リンブルガー語' },
  lin: { ja: 'リンガラ語', en: 'en_リンガラ語' },
  lit: { ja: 'リトアニア語', en: 'en_リトアニア語' },
  lol: { ja: 'モンゴ語', en: 'en_モンゴ語' },
  loz: { ja: 'ロズィ語', en: 'en_ロズィ語' },
  ltz: { ja: 'ルクセンブルク語', en: 'en_ルクセンブルク語' },
  lua: { ja: 'ルバ・ルルア小語群', en: 'en_ルバ・ルルア小語群' },
  lub: { ja: 'キルバ語', en: 'en_キルバ語' },
  lug: { ja: 'ガンダ語', en: 'en_ガンダ語' },
  lui: { ja: 'ルイセーニョ語', en: 'en_ルイセーニョ語' },
  lun: { ja: 'ルンダ語', en: 'en_ルンダ語' },
  luo: { ja: 'ルオ語', en: 'en_ルオ語' },
  lus: { ja: 'ルシャイ語', en: 'en_ルシャイ語' },
  mac: { ja: 'マケドニア語', en: 'en_マケドニア語' },
  mkd: { ja: 'マケドニア語', en: 'en_マケドニア語' },
  mad: { ja: 'マドゥラ語', en: 'en_マドゥラ語' },
  mag: { ja: 'マガヒー語', en: 'en_マガヒー語' },
  mah: { ja: 'マーシャル語', en: 'en_マーシャル語' },
  mai: { ja: 'マイティリー語', en: 'en_マイティリー語' },
  mak: { ja: 'マカッサル語', en: 'en_マカッサル語' },
  mal: { ja: 'マラヤーラム語', en: 'en_マラヤーラム語' },
  man: { ja: 'マンデ語；マンディンゴ語', en: 'en_マンデ語；マンディンゴ語' },
  mao: { ja: 'マオリ語', en: 'en_マオリ語' },
  mri: { ja: 'マオリ語', en: 'en_マオリ語' },
  map: { ja: 'オーストロネシア語族(その他)', en: 'en_オーストロネシア語族(その他)' },
  mar: { ja: 'マラーティー語', en: 'en_マラーティー語' },
  mas: { ja: 'マサイ語', en: 'en_マサイ語' },
  may: { ja: 'マレー語', en: 'en_マレー語' },
  msa: { ja: 'マレー語', en: 'en_マレー語' },
  mdf: { ja: 'モクシャ語', en: 'en_モクシャ語' },
  mdr: { ja: 'マンダル語', en: 'en_マンダル語' },
  men: { ja: 'メンデ語', en: 'en_メンデ語' },
  mga: { ja: '中期アイルランド語', en: 'en_中期アイルランド語' },
  mic: { ja: 'ミクマック語', en: 'en_ミクマック語' },
  min: { ja: 'ミナンカバウ語', en: 'en_ミナンカバウ語' },
  mis: { ja: 'その他の言語', en: 'en_その他の言語' },
  mkh: { ja: 'モン・クメール語派(その他)', en: 'en_モン・クメール語派(その他)' },
  mlg: { ja: 'マラガシ語', en: 'en_マラガシ語' },
  mlt: { ja: 'マルタ語', en: 'en_マルタ語' },
  mnc: { ja: '満州語', en: 'en_満州語' },
  mni: { ja: 'マニプル語', en: 'en_マニプル語' },
  mno: { ja: 'マノボ語族', en: 'en_マノボ語族' },
  moh: { ja: 'モホーク語', en: 'en_モホーク語' },
  mol: { ja: 'モルダビア語', en: 'en_モルダビア語' },
  mon: { ja: '満州語；モンゴル語', en: 'en_満州語；モンゴル語' },
  mos: { ja: 'モシ語', en: 'en_モシ語' },
  mul: { ja: '複数言語', en: 'en_複数言語' },
  mun: { ja: 'ムンダー諸語', en: 'en_ムンダー諸語' },
  mus: { ja: 'クリーク語', en: 'en_クリーク語' },
  mwl: { ja: 'ミランダ語', en: 'en_ミランダ語' },
  mwr: { ja: 'マールワーリー語', en: 'en_マールワーリー語' },
  myn: { ja: 'マヤ語族', en: 'en_マヤ語族' },
  myv: { ja: 'エルジャ語', en: 'en_エルジャ語' },
  nah: { ja: 'ナワトル語', en: 'en_ナワトル語' },
  nai: { ja: '北米インディアン諸語(その他)', en: 'en_北米インディアン諸語(その他)' },
  nap: { ja: 'ナポリ語', en: 'en_ナポリ語' },
  nau: { ja: 'ナウル語', en: 'en_ナウル語' },
  nav: { ja: 'ナバホ語', en: 'en_ナバホ語' },
  nbl: { ja: '南ンデベレ語', en: 'en_南ンデベレ語' },
  nde: { ja: '北ンデベレ語', en: 'en_北ンデベレ語' },
  ndo: { ja: 'ンドゥンガ語', en: 'en_ンドゥンガ語' },
  nds: { ja: '低地ドイツ語', en: 'en_低地ドイツ語' },
  nep: { ja: 'ネパール語', en: 'en_ネパール語' },
  new: { ja: 'ネワール語', en: 'en_ネワール語' },
  nia: { ja: 'ニアス語', en: 'en_ニアス語' },
  nic: { ja: 'ニジェール・コルドファン語族(その他)', en: 'en_ニジェール・コルドファン語族(その他)' },
  niu: { ja: 'ニウエー語', en: 'en_ニウエー語' },
  nno: { ja: 'ニューノシュク', en: 'en_ニューノシュク' },
  nob: { ja: 'ブークモール', en: 'en_ブークモール' },
  nog: { ja: 'ノガイ語', en: 'en_ノガイ語' },
  non: { ja: '古ノルド語', en: 'en_古ノルド語' },
  nor: { ja: 'ノルウェー語', en: 'en_ノルウェー語' },
  nqo: { ja: 'ンコ語', en: 'en_ンコ語' },
  nso: { ja: '北ソト語', en: 'en_北ソト語' },
  nub: { ja: 'ヌビア語群', en: 'en_ヌビア語群' },
  nwc: { ja: '古典ネワール語', en: 'en_古典ネワール語' },
  nya: { ja: 'チェワ語；ニャンジャ語', en: 'en_チェワ語；ニャンジャ語' },
  nym: { ja: 'ニャムウェズィ語', en: 'en_ニャムウェズィ語' },
  nyn: { ja: 'ニャンコレ語', en: 'en_ニャンコレ語' },
  nyo: { ja: 'ニョロ語', en: 'en_ニョロ語' },
  nzi: { ja: 'ンジマ語', en: 'en_ンジマ語' },
  oci: { ja: 'オック語', en: 'en_オック語' },
  oji: { ja: 'オジブワ語', en: 'en_オジブワ語' },
  ori: { ja: 'オリヤー語', en: 'en_オリヤー語' },
  orm: { ja: 'オロモ語；ガッラ語', en: 'en_オロモ語；ガッラ語' },
  osa: { ja: 'オセージ語', en: 'en_オセージ語' },
  oss: { ja: 'オセット語', en: 'en_オセット語' },
  ota: { ja: 'オスマン・トルコ語', en: 'en_オスマン・トルコ語' },
  oto: { ja: 'オトミ語', en: 'en_オトミ語' },
  paa: { ja: 'パプア諸語(その他)', en: 'en_パプア諸語(その他)' },
  pag: { ja: 'パンガシナン語', en: 'en_パンガシナン語' },
  pal: { ja: '中期ペルシア語；パフラビ語', en: 'en_中期ペルシア語；パフラビ語' },
  pam: { ja: 'カパンパンガン語', en: 'en_カパンパンガン語' },
  pan: { ja: 'パンジャーブ語', en: 'en_パンジャーブ語' },
  pap: { ja: 'パピアメント語', en: 'en_パピアメント語' },
  pau: { ja: 'パラオ語', en: 'en_パラオ語' },
  peo: { ja: '古代ペルシア語', en: 'en_古代ペルシア語' },
  per: { ja: 'ペルシア語', en: 'en_ペルシア語' },
  fas: { ja: 'ペルシア語', en: 'en_ペルシア語' },
  phi: { ja: 'フィリピン諸語(その他)', en: 'en_フィリピン諸語(その他)' },
  phn: { ja: 'フェニキア語', en: 'en_フェニキア語' },
  pli: { ja: 'パーリ語', en: 'en_パーリ語' },
  pol: { ja: 'ポーランド語', en: 'en_ポーランド語' },
  pon: { ja: 'ポナペ語', en: 'en_ポナペ語' },
  por: { ja: 'ポルトガル語', en: 'en_ポルトガル語' },
  pra: { ja: 'プラークリット語', en: 'en_プラークリット語' },
  pro: { ja: 'プロバンス語', en: 'en_プロバンス語' },
  pus: { ja: 'パシュトー語', en: 'en_パシュトー語' },
  'qaa-qtz': { ja: '局地用', en: 'en_局地用' },
  que: { ja: 'ケチュア語', en: 'en_ケチュア語' },
  raj: { ja: 'ラージャスターン語', en: 'en_ラージャスターン語' },
  rap: { ja: 'ラパヌイ語', en: 'en_ラパヌイ語' },
  rar: { ja: 'ラロトンガ語', en: 'en_ラロトンガ語' },
  roa: { ja: 'ロマンス諸語(その他)', en: 'en_ロマンス諸語(その他)' },
  roh: { ja: 'レト・ロマンス語；ロマンシュ語', en: 'en_レト・ロマンス語；ロマンシュ語' },
  rom: { ja: 'ロマーニー語', en: 'en_ロマーニー語' },
  rum: { ja: 'ルーマニア語', en: 'en_ルーマニア語' },
  ron: { ja: 'ルーマニア語', en: 'en_ルーマニア語' },
  run: { ja: 'ルンディ語', en: 'en_ルンディ語' },
  rup: { ja: 'アルーマニア語；マケド・ルーマニア語', en: 'en_アルーマニア語；マケド・ルーマニア語' },
  rus: { ja: 'ロシア語', en: 'en_ロシア語' },
  sad: { ja: 'サンダウェ語', en: 'en_サンダウェ語' },
  sag: { ja: 'サンゴ語', en: 'en_サンゴ語' },
  sah: { ja: 'ヤクート語', en: 'en_ヤクート語' },
  sai: { ja: '南米インディアン諸語(その他)', en: 'en_南米インディアン諸語(その他)' },
  sal: { ja: 'セイリッシュ語族', en: 'en_セイリッシュ語族' },
  sam: { ja: 'サマリア・アラム語', en: 'en_サマリア・アラム語' },
  san: { ja: 'サンスクリット語', en: 'en_サンスクリット語' },
  sas: { ja: 'ササク語', en: 'en_ササク語' },
  sat: { ja: 'サンタール語', en: 'en_サンタール語' },
  scc: { ja: 'セルビア語', en: 'en_セルビア語' },
  srp: { ja: 'セルビア語', en: 'en_セルビア語' },
  scn: { ja: 'シチリア語', en: 'en_シチリア語' },
  sco: { ja: '低地スコットランド・ゲール語', en: 'en_低地スコットランド・ゲール語' },
  scr: { ja: 'クロアチア語', en: 'en_クロアチア語' },
  hrv: { ja: 'クロアチア語', en: 'en_クロアチア語' },
  sel: { ja: 'セリクプ語', en: 'en_セリクプ語' },
  sem: { ja: 'セム語族(その他)', en: 'en_セム語族(その他)' },
  sga: { ja: '古アイルランド語', en: 'en_古アイルランド語' },
  sgn: { ja: '手話', en: 'en_手話' },
  shn: { ja: 'シャン語', en: 'en_シャン語' },
  sid: { ja: 'シダモ語', en: 'en_シダモ語' },
  sin: { ja: 'シンハラ語', en: 'en_シンハラ語' },
  sio: { ja: 'スー語族', en: 'en_スー語族' },
  sit: { ja: 'シナ・チベット語族(その他)', en: 'en_シナ・チベット語族(その他)' },
  sla: { ja: 'スラブ語派(その他)', en: 'en_スラブ語派(その他)' },
  slo: { ja: 'スロバキア語', en: 'en_スロバキア語' },
  slk: { ja: 'スロバキア語', en: 'en_スロバキア語' },
  slv: { ja: 'スロベニア語', en: 'en_スロベニア語' },
  sma: { ja: '南サーミ語', en: 'en_南サーミ語' },
  sme: { ja: '北サーミ語', en: 'en_北サーミ語' },
  smi: { ja: 'サーミ語(その他)', en: 'en_サーミ語(その他)' },
  smj: { ja: 'ルレ・サーミ語', en: 'en_ルレ・サーミ語' },
  smn: { ja: 'イナリ・サーミ語', en: 'en_イナリ・サーミ語' },
  smo: { ja: 'サモア語', en: 'en_サモア語' },
  sms: { ja: 'スコルト・サーミ語', en: 'en_スコルト・サーミ語' },
  sna: { ja: 'ショナ語', en: 'en_ショナ語' },
  snd: { ja: 'シンド語', en: 'en_シンド語' },
  snk: { ja: 'ソニンケ語', en: 'en_ソニンケ語' },
  sog: { ja: 'ソグド語', en: 'en_ソグド語' },
  som: { ja: 'ソマリ語', en: 'en_ソマリ語' },
  son: { ja: 'ソンガイ語', en: 'en_ソンガイ語' },
  sot: { ja: '南ソト語', en: 'en_南ソト語' },
  spa: { ja: 'スペイン語；カスティーヤ語', en: 'en_スペイン語；カスティーヤ語' },
  srd: { ja: 'サルデーニャ語', en: 'en_サルデーニャ語' },
  srn: { ja: 'スラナン語', en: 'en_スラナン語' },
  srr: { ja: 'セレル語', en: 'en_セレル語' },
  ssa: { ja: 'ナイル・サハラ言語群(その他)', en: 'en_ナイル・サハラ言語群(その他)' },
  ssw: { ja: 'スワティ語', en: 'en_スワティ語' },
  suk: { ja: 'スクマ語', en: 'en_スクマ語' },
  sun: { ja: 'スンダ語', en: 'en_スンダ語' },
  sus: { ja: 'スス語', en: 'en_スス語' },
  sux: { ja: 'シュメール語', en: 'en_シュメール語' },
  swa: { ja: 'スワヒリ語', en: 'en_スワヒリ語' },
  swe: { ja: 'スウェーデン語', en: 'en_スウェーデン語' },
  syc: { ja: '古典シリア語', en: 'en_古典シリア語' },
  syr: { ja: 'シリア語', en: 'en_シリア語' },
  tah: { ja: 'タヒチ語', en: 'en_タヒチ語' },
  tai: { ja: 'タイ諸語(その他)', en: 'en_タイ諸語(その他)' },
  tam: { ja: 'タミル語', en: 'en_タミル語' },
  tat: { ja: 'タタール語', en: 'en_タタール語' },
  tel: { ja: 'テルグ語', en: 'en_テルグ語' },
  tem: { ja: 'テムネ語', en: 'en_テムネ語' },
  ter: { ja: 'テレーノ語', en: 'en_テレーノ語' },
  tet: { ja: 'テトゥン語', en: 'en_テトゥン語' },
  tgk: { ja: 'タジク語', en: 'en_タジク語' },
  tgl: { ja: 'タガログ語', en: 'en_タガログ語' },
  tha: { ja: 'タイ語', en: 'en_タイ語' },
  tib: { ja: 'チベット語', en: 'en_チベット語' },
  bod: { ja: 'チベット語', en: 'en_チベット語' },
  tig: { ja: 'ティグレ語', en: 'en_ティグレ語' },
  tir: { ja: 'ティグリニア語', en: 'en_ティグリニア語' },
  tiv: { ja: 'ティブ語', en: 'en_ティブ語' },
  tkl: { ja: 'トケラウ語', en: 'en_トケラウ語' },
  tlh: { ja: 'クリンゴン語', en: 'en_クリンゴン語' },
  tli: { ja: 'トリンギット語', en: 'en_トリンギット語' },
  tmh: { ja: 'トゥアレグ語', en: 'en_トゥアレグ語' },
  tog: { ja: 'トンガ語(ニヤサ地方)', en: 'en_トンガ語(ニヤサ地方)' },
  ton: { ja: 'トンガ語(トンガ諸島)', en: 'en_トンガ語(トンガ諸島)' },
  tpi: { ja: 'トク・ピシン', en: 'en_トク・ピシン' },
  tsi: { ja: 'ツィムシアン語', en: 'en_ツィムシアン語' },
  tsn: { ja: 'ツワナ語', en: 'en_ツワナ語' },
  tso: { ja: 'ツォンガ語', en: 'en_ツォンガ語' },
  tuk: { ja: 'トルクメン語', en: 'en_トルクメン語' },
  tum: { ja: 'トゥンブカ語', en: 'en_トゥンブカ語' },
  tup: { ja: 'トゥピ語族', en: 'en_トゥピ語族' },
  tur: { ja: 'トルコ語', en: 'en_トルコ語' },
  tut: { ja: 'アルタイ諸言語(その他)', en: 'en_アルタイ諸言語(その他)' },
  tvl: { ja: 'ツバル語', en: 'en_ツバル語' },
  twi: { ja: 'チュイ語', en: 'en_チュイ語' },
  tyv: { ja: 'トゥワ語', en: 'en_トゥワ語' },
  udm: { ja: 'ウドムルト語', en: 'en_ウドムルト語' },
  uga: { ja: 'ウガリト語', en: 'en_ウガリト語' },
  uig: { ja: 'ウイグル語', en: 'en_ウイグル語' },
  ukr: { ja: 'ウクライナ語', en: 'en_ウクライナ語' },
  umb: { ja: 'ウンブンドゥ語', en: 'en_ウンブンドゥ語' },
  und: { ja: '不明言語', en: 'en_不明言語' },
  urd: { ja: 'ウルドゥー語', en: 'en_ウルドゥー語' },
  uzb: { ja: 'ウズベク語', en: 'en_ウズベク語' },
  vai: { ja: 'バイ語', en: 'en_バイ語' },
  ven: { ja: 'ベンダ語', en: 'en_ベンダ語' },
  vie: { ja: 'ベトナム語', en: 'en_ベトナム語' },
  vol: { ja: 'ボラピューク語', en: 'en_ボラピューク語' },
  vot: { ja: 'ボート語', en: 'en_ボート語' },
  wak: { ja: 'ワカシュ語族', en: 'en_ワカシュ語族' },
  wal: { ja: 'ワッラモ語', en: 'en_ワッラモ語' },
  war: { ja: 'ワライ語', en: 'en_ワライ語' },
  was: { ja: 'ワショ語', en: 'en_ワショ語' },
  wel: { ja: 'ウェールズ語', en: 'en_ウェールズ語' },
  cym: { ja: 'ウェールズ語', en: 'en_ウェールズ語' },
  wen: { ja: 'ソルブ語', en: 'en_ソルブ語' },
  wln: { ja: 'ワロン語', en: 'en_ワロン語' },
  wol: { ja: 'ウォロフ語', en: 'en_ウォロフ語' },
  xal: { ja: 'カルムイク語；オイラト語', en: 'en_カルムイク語；オイラト語' },
  xho: { ja: 'コサ語', en: 'en_コサ語' },
  yao: { ja: 'ヤオ語', en: 'en_ヤオ語' },
  yap: { ja: 'ヤップ語', en: 'en_ヤップ語' },
  yid: { ja: 'イディッシュ語', en: 'en_イディッシュ語' },
  yor: { ja: 'ヨルバ語', en: 'en_ヨルバ語' },
  ypk: { ja: 'ユピック語', en: 'en_ユピック語' },
  zap: { ja: 'サポテック語', en: 'en_サポテック語' },
  zbl: { ja: '', en: 'en_' },
  zen: { ja: 'ゼナガ語', en: 'en_ゼナガ語' },
  zha: { ja: 'チュワン語', en: 'en_チュワン語' },
  znd: { ja: 'ザンデ語', en: 'en_ザンデ語' },
  zul: { ja: 'ズールー語', en: 'en_ズールー語' },
  zun: { ja: 'ズニ語', en: 'en_ズニ語' },
  zxx: { ja: '言語的内容なし', en: 'en_言語的内容なし' },
  zza: { ja: 'ザザキ語', en: 'en_ザザキ語' },
}

export default languageLabel
